export enum DiscountType {
  FIXED_AMOUNT = "FIXED_AMOUNT",
  PERCENTAGE = "PERCENTAGE",
}

export interface Discount {
  type: DiscountType;
  amount: number;
  expires?: Date;
}
